import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Spin, Select, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import ServicioAdministracion from '../../servicios/ServicioAdministracion'
import { withCookies } from 'react-cookie';
import Constantes from '../../utilidades/Constantes'
import Utilidades from '../../utilidades/Utilidades';
import ReporteUsuarios from './ReporteUsuarios';
import ReportePersonasJuridicas from './ReportePersonasJuridicas';
import ReportePersonasNaturales from './ReportePersonasNaturales';
import ReporteApoderados from './ReporteApoderados'
import ReporteRepresentantesLegales from './ReporteRepresentantesLegales';
import {
    ReporteUsuariosDetallado, ReportePersonasJuridicasDetallado,
    ReportePersonasNaturalesDetallado, ReporteRepresentantesLegalesDetallado,
    ReporteApoderadosDetallado
} from './ReportesUsuariosDetallados';

const { Option } = Select;

class ReportesUsuarios extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
        NO_HABILITADO: 4,
    }

    state = {
        hijoCargado: false,
        componente: this.ENUM_COMPONENTE.CARGANDO,
    };

    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);
        // Esta variable contiene la referencia al reporte que se está viendo
        this.reporteHijo = React.createRef()
    }



    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario esté en sesion
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr != null) {
            // Valida que tenga la accion habilitada de acceder 
            let habilitado = await this.servicioUsuarios.accionHabilitadaPromesa(Constantes.ENUMS_MODULOS.REPORTES.ACCIONES.VER_REPORTES_USUARIOS.id);
            if (habilitado && habilitado.resultado) {
                let detallado = await this.servicioUsuarios.accionHabilitadaPromesa(Constantes.ENUMS_MODULOS.REPORTES.ACCIONES.REPORTE_DETALLADO_USUARIOS.id);
                this.setSumaState({ usuario: usr, componente: this.ENUM_COMPONENTE.VER, detallado: detallado.resultado });
            } else {
                this.setSumaState({ usuario: usr, componente: this.ENUM_COMPONENTE.NO_HABILITADO });
            }
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
    }

    descargarReporte = e => {
        if (this.reporteHijo && this.reporteHijo.descargarReporte) {
            // Si el reporte hijo contiene la función 'descargarReporte' la ejecuta
            this.reporteHijo.descargarReporte();
        }
    }


    render() {

        const { componente, usuario, opcion, hijoCargado, detallado } = this.state;

        const seleccionTipoReporte = opcion => {
            this.setSumaState({ opcion, hijoCargado: false });
            this.reporteHijo = React.createRef();
        };

        return (
            <>
                <div className="seccion-principal contenedor-completo seccion-flex ">
                    <div className="division-contenido seccion-flex-grow-1  bkg-white contenido-usuarios">

                        {(componente === this.ENUM_COMPONENTE.VER) ?
                            (
                                <>
                                    <div style={{ marginBottom: 20 }}>
                                        <label style={{ fontWeight: 'bold', marginRight: 10 }}>Tipo de reporte a generar</label>
                                        <Select defaultValue="usuarios" style={{ width: 200, marginRight: 10 }}
                                            onChange={seleccionTipoReporte}
                                            disabled={!hijoCargado}
                                        >
                                            <Option value="usuarios">Usuarios</Option>
                                            {detallado ? <Option value="usuarios-detallado">Usuarios (Detallado)</Option> : null}
                                            <Option value="personas-juridicas">Personas Jurídicas</Option>
                                            {detallado ? <Option value="personas-juridicas-detallado">Personas Jurídicas (Detallado)</Option> : null}
                                            <Option value="personas-naturales">Personas Naturales</Option>
                                            {detallado ? <Option value="personas-naturales-detallado">Personas Naturales (Detallado)</Option> : null}
                                            <Option value="representantes-legales">Representantes Legales</Option>
                                            {detallado ? <Option value="representantes-legales-detallado">Representantes Legales (Detallado)</Option> : null}
                                            <Option value="apoderados">Apoderados</Option>
                                            {detallado ? <Option value="apoderados-detallado">Apoderados (Detallado)</Option> : null}
                                        </Select>

                                        <Button type="primary"
                                            icon={<DownloadOutlined />}
                                            onClick={this.descargarReporte}
                                            disabled={
                                                !Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.REPORTES.ACCIONES.DESCARGAR_REPORTE_USUARIOS.id)
                                                || !hijoCargado
                                            }
                                        >
                                            Descargar
                                        </Button>
                                    </div>
                                    {
                                        opcion === 'personas-juridicas' ?
                                            <ReportePersonasJuridicas onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                            :
                                            opcion === 'personas-juridicas-detallado' ?
                                                <ReportePersonasJuridicasDetallado onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                :
                                                opcion === 'personas-naturales' ?
                                                    <ReportePersonasNaturales onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                    :
                                                    opcion === 'personas-naturales-detallado' ?
                                                        <ReportePersonasNaturalesDetallado onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                        :
                                                        opcion === 'apoderados' ?
                                                            <ReporteApoderados onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                            :
                                                            opcion === 'apoderados-detallado' ?
                                                                <ReporteApoderadosDetallado onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                                :
                                                                opcion === 'representantes-legales' ?
                                                                    <ReporteRepresentantesLegales onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                                    :
                                                                    opcion === 'representantes-legales-detallado' ?
                                                                        <ReporteRepresentantesLegalesDetallado onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                                        :
                                                                        !opcion || opcion === 'usuarios' || opcion === 'usuarios-detallado' ?
                                                                            (
                                                                                !opcion || opcion === 'usuarios' ?
                                                                                    <ReporteUsuarios onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                                                    :
                                                                                    <ReporteUsuariosDetallado opcion={opcion} onRef={ref => (this.reporteHijo = ref)} onCargado={cargado => (this.setSumaState({ hijoCargado: cargado }))} />
                                                                            )
                                                                            :
                                                                            null
                                    }

                                </>
                            )
                            :
                            (componente === this.ENUM_COMPONENTE.NO_HABILITADO) ?
                                <>
                                    Reportes de usuarios no disponibles. {Constantes.MENSAJE_USUARIO_SIN_PERMISOS}
                                </> :
                                (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                                    (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                                    : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:REPORTESUSUARIOS]</label>) : (<></>))
                        }
                    </div>
                </div>
            </>
        );

    }

}

export default withRouter(withCookies(ReportesUsuarios));